module.exports = __webpack_public_path__ + "assets/img/ko-111a2e33.png";